import { useState } from "react";
import { AddableCourse, CourseLite, CourseSummary } from "../../types/course.response";
import { Requirement, Select, CourseSet } from "../../types/requirement.response";
import ChecklistCourseSetSlots from "./ChecklistCourseSetSlots";
import RequirementTabBar from "../shared/RequirementTabBar";

interface ChecklistOptionSectionProps {
    rootNode: Select;
    requirement: Requirement;
    coursesMap: Record<string, CourseSummary>;
    onAdd: (course: AddableCourse, nodeId: string | null) => void | Promise<void>;
    onDelete: (course: CourseLite) => void | Promise<void>;
}

export default function ChecklistOptionSection({
    rootNode,
    requirement,
    coursesMap,
    onAdd,
    onDelete,
}: ChecklistOptionSectionProps) {
    const children = rootNode.children.filter(
        (child): child is CourseSet => child.type === "COURSE_SET"
    );
    const [activeTab, setActiveTab] = useState(0);

    if (children.length === 0) return null;

    const activeChild = children[activeTab];

    return (
        <div>
            <RequirementTabBar
                items={children}
                fulfilledIds={rootNode.fulfilledChildIds}
                activeTab={activeTab}
                onTabChange={setActiveTab}
            />

            <div className="mt-3 flex flex-col gap-3">
                <ChecklistCourseSetSlots
                    key={activeChild.id}
                    courseSet={activeChild}
                    coursesMap={coursesMap}
                    requirementId={requirement.info.id}
                    onAdd={(course) => onAdd(course, activeChild.id)}
                    onAddExtra={(course) => onAdd(course, null)}
                    onDelete={onDelete}
                    idPrefix="checklist-option"
                />
            </div>
        </div>
    );
}
